import request from '@/utils/request'

const prefix = '/django_rest/survey'
export default {
  searchSurvey: (params) => {
    return request.get(`${prefix}/`, { params })
  },
  getSurveyById: (id) => {
    return request.get(`${prefix}/${id}`)
  },
  updateSurvey: (survey) => {
    return request.put(`${prefix}/${survey.id}`, survey)
  },
  getSurveyInfo: (companyId) => {
    return request.get(`${prefix}/company/${companyId}/`)
  },
  getSurveyQuestion: (companyId) => {
    return request.get(`${prefix}/answer/${companyId}/`)
  },
  answerSurveyQuestion: (companyId, question) => {
    return request.post(`${prefix}/answer/${companyId}/`, question)
  },
  getSurveyPreference: (params) => {
    return request.get(`${prefix}/notification/${params.companyId}/`, { params })
  },
  updateSurveyPreference: (companyId, preference) => {
    return request.post(`${prefix}/notification/${companyId}/`, preference)
  },
  getCompanySurveySimpleInfo: (companyId) => {
    return request.get(`${prefix}/company/simple-info/${companyId}/`)
  },
  getCompanySurveyQuestionList (params) {
    return request.get(`${prefix}/question/`, { params })
  }
}
